export const FeatureFlags = {
  MSF_DELIVERY_ITEM_DELETION: 1286,
};

export const FETCH_PICKUP_POINTS_FROM_GRAPHQL =
  'deliveryPageUseGraphQlPickupPoint';
export const FETCH_DELIVERY_MESSAGES_FROM_GRAPHQL =
  'deliveryPageUseGraphQlMessages';

export const SELECT_SINGLE_PROMISE_FROM_GRAPHQL =
  'deliveryPageUseGraphQlSelectSinglePromise';
export const SELECT_ALL_PROMISES_FROM_GRAPHQL =
  'deliveryPageUseGraphQlSelectAllPromises';
export const FETCH_SCHEDULED_SLOTS_FROM_GRAPHQL =
  'deliveryPageUseGraphQlScheduleDeliverySlots';
export const FETCH_DELIVERY_OFFERS_FROM_GRAPHQL =
  'productPageUseGraphQlDeliveryOffers';

export const PRODUCT_PAGE_REVAMP = 'productPageRevampV2';

export const PAY_BOX_REVAMP = 'deliveryPagePayBoxRevamp';

export const PICKUP_POINTS_REVAMP = 'deliveryPagePickupPointRevamp';
